import React from 'react'

const ImageViewer = ({ src, className, props }) => {
    return (
        <img src={src} className={'img-thumbnail card-image ' + className} {...props} />
    )
}

export default ImageViewer